export const TIPOS_TEXTO_LEGAL = [
    { campo: 'avislegal', etiqueta: 'Aviso Legal' },
    { campo: 'terminosycondiciones', etiqueta: 'Términos y Condiciones' },
    { campo: 'politicaprivadesa', etiqueta: 'Política de privacidad' },
    { campo: 'politicaprivadesaxarxessocials', etiqueta: 'Política de privacidad RRSS' },
    { campo: 'politicacookies', etiqueta: 'Política de cookies' },
];

export const AMBITO_GLOBAL = 'global';

const ETIQUETA_HTML = /<[^>]*>/g;
const ENTIDAD_ESPACIO_NO_SEPARABLE = /&nbsp;/gi;

// Misma regla que el backend: el editor manda `<p></p>` o `<p><br></p>` al borrar el texto.
export const esTextoLegalVacio = (texto) => {
    if (typeof texto !== 'string') return true;

    const textoSinMarcado = texto.replace(ETIQUETA_HTML, '').replace(ENTIDAD_ESPACIO_NO_SEPARABLE, '');
    return textoSinMarcado.trim() === '';
};

const construirTextosDelAmbito = (textosDeOrigen) => {
    const textosDelAmbito = {};
    TIPOS_TEXTO_LEGAL.forEach(({ campo }) => {
        textosDelAmbito[campo] = textosDeOrigen?.[campo] || '';
    });
    return textosDelAmbito;
};

export const obtenerTiposVaciosDelGlobal = (textosGlobales) => TIPOS_TEXTO_LEGAL
    .filter(({ campo }) => esTextoLegalVacio(textosGlobales?.[campo]))
    .map(({ etiqueta }) => etiqueta);

/** Estado local de edición: `{ [ambito]: { cinco textos } }`, con cadena vacía en lo que no hay. */
export const construirBorradores = (respuestaTextosLegales) => {
    const borradores = { [AMBITO_GLOBAL]: construirTextosDelAmbito(respuestaTextosLegales?.global) };
    const sucursales = respuestaTextosLegales?.sucursales || [];
    sucursales.forEach(({ sucursal, textos }) => {
        borradores[sucursal] = construirTextosDelAmbito(textos);
    });
    return borradores;
};

const sonTextosIguales = (textoOriginal, textoBorrador) => {
    const ambosVacios = esTextoLegalVacio(textoOriginal) && esTextoLegalVacio(textoBorrador);
    if (ambosVacios) return true;
    return textoOriginal === textoBorrador;
};

const esAmbitoModificado = (textosOriginales, textosBorrador) => TIPOS_TEXTO_LEGAL.some(({ campo }) => (
    !sonTextosIguales(textosOriginales?.[campo], textosBorrador?.[campo])
));

/** Ámbitos con algún texto cambiado, siempre con el global delante: se guarda primero. */
export const detectarAmbitosModificados = (original, borradores) => {
    const ambitosDeSucursal = Object.keys(original).filter(ambito => ambito !== AMBITO_GLOBAL);
    return [AMBITO_GLOBAL, ...ambitosDeSucursal]
        .filter(ambito => esAmbitoModificado(original[ambito], borradores[ambito]));
};

/**
 * Tras un guardado, cada ámbito toma lo que devuelve el servidor salvo los que seguían pendientes
 * frente a lo cargado antes: si un guardado de varios ámbitos falla a medias, lo escrito en los que
 * no se llegaron a guardar no se pierde.
 */
export const conservarBorradoresPendientes = (originalAnterior, originalNuevo, borradores) => {
    const ambitosPendientes = originalAnterior ? detectarAmbitosModificados(originalAnterior, borradores) : [];
    const borradoresActualizados = {};
    Object.keys(originalNuevo).forEach((ambito) => {
        const sigueSinGuardar = ambitosPendientes.includes(ambito) && Boolean(borradores[ambito]);
        borradoresActualizados[ambito] = sigueSinGuardar ? borradores[ambito] : originalNuevo[ambito];
    });
    return borradoresActualizados;
};

export const construirBodyGuardado = (ambito, textos) => ({
    sucursal: ambito === AMBITO_GLOBAL ? null : ambito,
    textos,
});

export const sucursalTieneTextoPropio = (borradores, ambito, campo) => {
    if (ambito === AMBITO_GLOBAL) return false;
    return !esTextoLegalVacio(borradores[ambito]?.[campo]);
};
